import { gql } from '@apollo/client'

export const DELETE_CLUB_TRACKING_GROUPS = gql`
  mutation DeleteClubTrackingGroups($clubId: ID!) {
    deleteClubTrackingGroups(clubId: $clubId)
  }
`
